import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInteger: number;
};

export type ContactDetailsDtoInput = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organisation: Scalars['String'];
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  calculateRoi: RoiCalculationDto;
};


/** Mutation root */
export type MutationCalculateRoiArgs = {
  input: RoiInputDtoInput;
};

export type ProjectDataInputDtoInput = {
  contractValue: Scalars['BigInteger'];
  duration: Scalars['Int'];
  numEvaluators: Scalars['Int'];
  numProcurements: Scalars['Int'];
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  status?: Maybe<Scalars['String']>;
};

export type RoiCalculationDto = {
  __typename?: 'RoiCalculationDTO';
  annualProcessSavings: Scalars['BigInteger'];
  annualReductionsPaper: Scalars['Int'];
  annualReductionsTreesSaved: Scalars['Int'];
  annualRiskAvoidance: Scalars['BigInteger'];
  costOfPetrol: Scalars['BigInteger'];
  environmentalSaving: Scalars['BigInteger'];
  id: Scalars['BigInteger'];
  reducedClaims: Scalars['BigInteger'];
  reducedDelays: Scalars['BigInteger'];
  reducedRisk: Scalars['BigInteger'];
  reductionInChanges: Scalars['BigInteger'];
  reductionsForConsultancy: Scalars['BigInteger'];
  totalCostReductions: Scalars['BigInteger'];
  totalEfficiencySavings: Scalars['BigInteger'];
  totalSavings: Scalars['BigInteger'];
};

export type RoiInputDtoInput = {
  captchaToken?: InputMaybe<Scalars['String']>;
  contactDetailsData: ContactDetailsDtoInput;
  majorProjectData: ProjectDataInputDtoInput;
  strategicProjectData: ProjectDataInputDtoInput;
};

export type CalculateRoiMutationVariables = Exact<{
  input: RoiInputDtoInput;
}>;


export type CalculateRoiMutation = { __typename?: 'Mutation', calculateRoi: { __typename?: 'RoiCalculationDTO', id: number, totalSavings: number, totalEfficiencySavings: number, totalCostReductions: number, reductionsForConsultancy: number, annualProcessSavings: number, reductionInChanges: number, reducedRisk: number, reducedClaims: number, annualRiskAvoidance: number, annualReductionsPaper: number, annualReductionsTreesSaved: number, reducedDelays: number, costOfPetrol: number, environmentalSaving: number } };


export const CalculateRoiDocument = gql`
    mutation calculateRoi($input: RoiInputDTOInput!) {
  calculateRoi(input: $input) {
    id
    totalSavings
    totalEfficiencySavings
    totalCostReductions
    reductionsForConsultancy
    annualProcessSavings
    reductionInChanges
    reducedRisk
    reducedClaims
    annualRiskAvoidance
    annualReductionsPaper
    annualReductionsTreesSaved
    reducedDelays
    costOfPetrol
    environmentalSaving
  }
}
    `;

/**
 * __useCalculateRoiMutation__
 *
 * To run a mutation, you first call `useCalculateRoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateRoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateRoiMutation, { data, loading, error }] = useCalculateRoiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateRoiMutation(baseOptions?: Apollo.MutationHookOptions<CalculateRoiMutation, CalculateRoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateRoiMutation, CalculateRoiMutationVariables>(CalculateRoiDocument, options);
      }
export type CalculateRoiMutationHookResult = ReturnType<typeof useCalculateRoiMutation>;
export type CalculateRoiMutationResult = Apollo.MutationResult<CalculateRoiMutation>;